(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frameRequested = false;

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const updateParallax = () => {
    frameRequested = false;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    document.querySelectorAll('.kh, .kmy').forEach((root) => {
      const rect = root.getBoundingClientRect();
      if (rect.bottom < -120 || rect.top > viewportHeight + 120) return;
      const progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
      root.style.setProperty('--k-scroll-shift', `${(progress - .5) * 34}px`);
    });
  };

  const requestParallax = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateParallax);
  };

  const initHomeMotion = (scope = document) => {
    const body = document.body;
    if (!body?.classList.contains('template-index') || reducedMotion.matches) return;

    document.documentElement.classList.add('k-home-motion');

    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('k-home-inview');
        instance.unobserve(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -9% 0px' });

    const roots = scope.matches?.('.shopify-section') ? [scope] : scope.querySelectorAll?.('.shopify-section');
    roots?.forEach((section) => {
      if (section.dataset.kHomeReady === 'true') return;
      section.dataset.kHomeReady = 'true';
      if (section.querySelector('.kh, .kev, .kmy')) return;
      section.classList.add('k-home-reveal');
      observer.observe(section);
    });

    scope.querySelectorAll?.('.kh').forEach((hero) => {
      if (hero.dataset.kPointerReady === 'true') return;
      hero.dataset.kPointerReady = 'true';
      hero.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;
        const rect = hero.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - .5) * 14;
        const y = ((event.clientY - rect.top) / rect.height - .5) * 10;
        hero.style.setProperty('--k-pointer-x', `${x}px`);
        hero.style.setProperty('--k-pointer-y', `${y}px`);
      }, { passive: true });
      hero.addEventListener('pointerleave', () => {
        hero.style.setProperty('--k-pointer-x', '0px');
        hero.style.setProperty('--k-pointer-y', '0px');
      });
    });

    requestParallax();
  };

  const start = () => {
    initHomeMotion(document);
    window.addEventListener('scroll', requestParallax, { passive: true });
    window.addEventListener('resize', requestParallax, { passive: true });
    document.addEventListener('shopify:section:load', (event) => initHomeMotion(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
